import type {
  schemaType,
  returnType,
} from '~~/shared/api/rurality/v3/provinces/detail/schema'
import {
  serverFetchWrapper,
  browserFetchWrapper,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/provinces/detail'

export const serverFetch = (): Promise<returnType> =>
  serverFetchWrapper<never, schemaType>(endpoint)

export const browserFetch = (): Promise<returnType> =>
  browserFetchWrapper<never, schemaType>(endpoint)
